"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.display = void 0;
require("./display.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const display = {
  block: "cds-block-b1e67903",
  'inline-block': "cds-inline-block-iy68ghq",
  flex: "cds-flex-f1g67tkn",
  'inline-flex': "cds-inline-flex-id0hzyq",
  none: "cds-none-n1d7owh7",
  contents: "cds-contents-c1avhd66",
  grid: "cds-grid-g1mno7ew"
};
exports.display = display;